<template>
  <DataListStateful
    title="Склады"
    resource="warehouses"
    store="warehouses"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Телефон", name: "phone", sortable: true },
        { title: "Email", name: "email", sortable: true },
        {
          title: "Страна",
          name: "country",
          dataPath: "Country.Title",
          sortable: true,
        },
        {
          title: "Адрес",
          name: "addressTitle",
          dataPath: "Address.Title",
          sortable: false,
        },
        {
          title: "Группажный склад",
          name: "groupedWarehouse",
          dataPath: "GroupedWarehouse",
          type: "flag",
          sortable: false,
        },
        {
          title: "Расписание",
          name: "timetable",
          dataPath: "Timetable",
          sortable: false,
        },
        {
          title: "Специализация",
          name: "specialization",
          dataPath: "Specialization",
          sortable: false,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        country: {
          title: "Страна",
          type: "reference",
          resource: "countries",
        },
        address: {
          title: "Адрес",
          type: "reference",
          resource: "addresses",
        },
        timetable: {
          title: "Расписание",
          type: "text",
        },
        specialization: {
          title: "Специализация",
          type: "text",
        },
      },
    };
  },
};
</script>
